import { render, staticRenderFns } from "./TopbarDataMenu.vue?vue&type=template&id=fea88d7e&"
import script from "./TopbarDataMenu.vue?vue&type=script&lang=js&"
export * from "./TopbarDataMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports